import styled from '@emotion/styled';

export const SContainer = styled.div`
  background-color: white;
  padding: 16px 16px 24px;
  display: flex;
  justify-content: space-between;
`;

export const SProperties = styled.div`
  display: flex;
  margin-left: 105px;
  margin-top: 8px;
`;

export const SLabel = styled.div``;

export const SText = styled.b`
  font-size: 16px;
  line-height: 22px;
  margin-top: 4px;
`;

export const SValueSpacer = styled.div`
  margin-top: 4px;
`;

export const SProperty = styled.div``;
